import React from 'react';
import styled from 'styled-components';
import Grid from '@material-ui/core/Grid';

const ComingSoon = styled(Grid)`
  height: 48px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  color: ${props => props.theme.text};
`;

export default function CloudServices() {
  return <ComingSoon xs={12}>Coming Soon</ComingSoon>;
}
